import { MARK_PATH } from './LogoMark';

/**
 * INOU のロゴ。
 *
 * fill は currentColor なので、置き場所の text-* で色が決まる。
 * 既定はブランド色 (brand-500)。濃色サーフェスの上では text-surface-raised
 * などを当てて反転させる。
 *
 * viewBox は元データ (675x265) の余白を落として実際の描画範囲に詰めてある。
 */
export interface LogoProps {
  /** 描画高 (px)。幅はアスペクト比 556:229 から決まる。 */
  height?: number;
  className?: string;
}

export function Logo({ height = 24, className }: LogoProps) {
  return (
    <svg
      height={height}
      // 幅も明示する。高さだけだと flex の子として置いたときに
      // align-items: stretch で横に引き伸ばされ、preserveAspectRatio の
      // 既定 (xMidYMid) によってロゴが列の中央に描かれてしまう。
      width={(height * 556) / 229}
      viewBox="60 18 556 229"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="INOU"
      className={className}
    >
      <path d={MARK_PATH} />
      <path d="M507.906 61H536.506V153.2C536.506 161.2 538.573 167.667 542.706 172.6C546.973 177.4 553.24 179.8 561.506 179.8C569.773 179.8 575.973 177.4 580.106 172.6C584.373 167.667 586.506 161.2 586.506 153.2V61H615.106V155C615.106 163.267 613.773 170.533 611.106 176.8C608.44 183.067 604.64 188.333 599.706 192.6C594.906 196.867 589.24 200.067 582.706 202.2C576.173 204.467 569.106 205.6 561.506 205.6C553.773 205.6 546.64 204.467 540.106 202.2C533.573 200.067 527.906 196.867 523.106 192.6C518.306 188.333 514.573 183.067 511.906 176.8C509.24 170.533 507.906 163.267 507.906 155V61Z" />
      <path d="M244.78 61H272.38V208L172.78 114.2V201H145.18V54L244.78 147.8V61Z" />
      <path d="M60 61H89V201H60V61Z" />
    </svg>
  );
}
